<template>
        <button class="next" type="submit" @click="openNextPanel()" :disabled="!isValid">{{ text }}</button>
</template>

<script>
    export default {
        name: 'NextButton',
        props: {
            text: {
                type: String,
                default: 'Volgende'
            },
            isValid: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                componentNames: []
            }
        },
        methods: {
            openNextPanel() {
                let components = this.$parent.$parent.$options.components;
                this.componentNames = Object.values(components).map(component => (component.name));

                let i = this.componentNames.indexOf(this.$store.state.panel.current);

                this.$store.dispatch(
                    'SetPanel',
                    this.componentNames[++i]
                )
            },
        }
    }
</script>